import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './Link.module.less'

const Link = ({ children, className, type, ...rest }) => {
  const classNames = cx({
    [styles.buttonLink]: true,
    'kiosk-color--primary-color': true,
    'kiosk-color--primary-color-hover': true,
    [className]: !!className,
  })

  return (
    <button type={type ? type : 'button'} className={classNames} {...rest}>
      {children}
    </button>
  )
}

Link.propTypes = {
  className: PropTypes.string,
}

export default Link
